import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Section } from './Shared';
const faqs = [{
  q: '¿Sirve si no soy terapeuta certificado?',
  a: 'Absolutamente. El Botiquín fue diseñado con dos lectores en mente: el terapeuta que necesita una herramienta clínica visual de consulta rápida, y la persona sin formación que quiere aliviar síntomas cotidianos con sus propias manos. Cada ficha tiene un lenguaje técnico en la columna lateral y una imagen intuitiva que cualquiera puede seguir.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después de tu compra recibís un email con el enlace de descarga. Acceso en menos de 5 minutos. Compatible con cualquier dispositivo: tablet, celular, computadora. Ideal para usar en consulta o imprimir en tamaño A4.'
}, {
  q: '¿Necesito imprimir todo el material?',
  a: 'No es obligatorio. El formato está optimizado para tablets y pantallas. Pero si querés tenerlo físico en tu consultorio, el diseño está preparado para impresión en alta calidad en A4.'
}, {
  q: '¿Qué lo diferencia de un libro de acupuntura tradicional?',
  a: 'Los libros técnicos de MTC están pensados para estudiar, no para aplicar en tiempo real. El Botiquín Ancestral está diseñado para abrirlo en el momento del síntoma y actuar en segundos. Una página, un punto, una solución. Sin buscar entre índices ni descifrar diagramas complejos.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días completos. Si no es lo que esperabas, te devolvemos el 100% sin preguntas. Sin formularios. Sin esperas.'
}, {
  q: '¿Puedo compartirlo con otros terapeutas?',
  a: 'El material es de uso personal y profesional individual. Está protegido por derechos de autor. Si querés que tus colegas tengan acceso, podés recomendarles adquirir su propio ejemplar.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const reduceMotion = useReducedMotion();
  return <Section className="max-w-3xl" data-id="element-65" data-mp="2poge7jmkmubu">
      <div className="mb-10 text-center" data-id="element-66" data-mp="2kvn5kknzf1uh">
        <h2 className="font-display text-3xl font-bold text-brand-ink md:text-4xl" data-id="element-67" data-mp="2kuls69jhu39l">
          LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>
      <div className="space-y-3" data-id="element-68" data-mp="2ay92dmr2k9k4">
        {faqs.map((faq, index) => {
        const isOpen = index === openIndex;
        return <article key={faq.q} className="glass-panel overflow-hidden rounded-2xl" data-id="element-69" data-mp="38kzedjfed7w9" data-mpi={index}>
              <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-5 py-5 text-left text-sm font-semibold text-brand-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-4px] focus-visible:outline-brand-forest md:px-6 md:text-base" data-id="element-70" data-mp="33klforzoraaw">
                <span data-id="element-71" data-mp="3uupqr0g6s4kb">{faq.q}</span>
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-goldDark transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-72" data-mp="3uvr9zs7cvxd4" />
              </button>
              <AnimatePresence initial={false} data-id="element-73" data-mp="7n42auoe4hbk">
                {isOpen && <motion.div initial={reduceMotion ? false : {
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={reduceMotion ? undefined : {
              opacity: 0,
              height: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-74" data-mp="chi35cltngnm">
                    <p className="border-t border-brand-green/20 bg-brand-paper/50 px-5 py-5 text-sm leading-relaxed text-brand-text md:px-6 md:text-base" data-id="element-75" data-mp="1wvv2vak44wyk">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </article>;
      })}
      </div>
    </Section>;
}